import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routing from './components/Routing';
import './input.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Routing/>
  </React.StrictMode>
);


